import 'css-chunksrc/client/common/tagForm/styles.scss';export default {
  "form": "_form_1k8ug_1",
  "main": "_main_1k8ug_8",
  "input": "_input_1k8ug_18",
  "button": "_button_1k8ug_32",
  "list": "_list_1k8ug_47",
  "item": "_item_1k8ug_53",
  "tagBadge": "_tagBadge_1k8ug_61"
};